((window, document, undefined, ext) => {

    'use strict';

    chatarea.init();
    notes.init();
    
})(window, document, undefined, {
    notes,
    chatarea,
    dom,
    file
});